export default {
  common: {
    email: 'Email',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    countrySelect: 'Choisir le pays',
    countryUnmodifiedNote: "Le pays ne peut pas être modifié après l'inscription",
    next: 'Suivant',
    back: 'Retour',
    attention: 'Attention',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    modify: 'Modifier',
    ignore: 'Ignorer',
    firstName: 'Prénom',
    middleName: 'Deuxième prénom',
    lastName: 'Nom de famille',
    gender: 'Sexe',
    male: 'Homme',
    female: 'Femme',
    birthday: 'Anniversaire',
    graphicCode: 'Code graphique',
    emailCode: "Code de vérification de l'e-mail",
    smsCode: 'Code SMS',
    smsVerificationCode: 'Code de vérification par SMS',
    bind: 'Lier',
    send: 'Envoyer',
    resend: 'Renvoyer',
    address: 'Adresse',
    done: 'Terminé',
    systemMessage: 'Message système',
    setting: 'Paramètre',
    submit: 'Envoyer',
    language: 'Langue',
    edit: 'Modifier',
    delete: 'Supprimer'
  },
  account: {
    account: 'Compte',
    nickname: 'Pseudonyme',
    id: 'ID',
    basicInfo: 'Niveau de base',
    placeholder: 'Veuillez saisir',
    completed: 'Terminé',
    semiInfo: 'Semi-vérifié',
    fullyInfo: 'Entièrement vérifié',
    basicTab: 'Basique',
    advancedTab: 'Avancé',
    linkedAccount: 'Compte de retrait lié',
    accountSecurity: 'Compte MetWallet et sécurité',
    logout: 'Déconnexion',
    semiToast: 'Veuillez effectuer la vérification de niveau de base',
    fullyToast: 'Veuillez effectuer la vérification de niveau de base \n et semi-vérifié',
    quickLoginTitle: 'Connexion rapide',
    cancelQuickLogin: 'Êtes-vous sûr de vouloir désactiver la connexion rapide ?'
  },
  accountSecurity: {
    title: 'Compte et sécurité',
    payPwd: 'Mot de passe de paiement',
    loginPwd: 'Mot de passe de connexion',
    changeEmail: "Modifier l'e-mail",
    changePhone: 'Modifier le numéro de téléphone',
    changePayPwd: 'Modifier le mot de passe de paiement',
    changeLoginPwd: 'Modifier le mot de passe de connexion',
    bindEmail: 'Lier un e-mail',
    bindEmailNote: "Réussir la vérification de l'e-mail pour le lier",
    bindEmailPlaceholder: "Entrez l'e-mail que vous souhaitez lier",
    smsBindNote: 'Passer la vérification par SMS pour le lier',
    bindPhone: 'Lier le numéro de téléphone',
    smsAuthentication: 'Authentification SMS',
    emailAuthentication: 'Authentification e-mail',
    phoneVerificationNote: "Réussir d'abord la vérification du numéro de téléphone actuel",
    bindPhonePlaceholder: 'Entrez le numéro de téléphone que vous souhaitez lier',
    verificationWrongToast: 'Veuillez vérifier votre code de vérification',
    phoneNumberEmptyToast: 'Veuillez saisir le numéro de téléphone',
    verificationCodeEmptyToast: 'Veuillez saisir le code',
    wrongCodeToast: 'Code erroné',
    changeNote: 'Veuillez passer la vérification pour la modifier.',
    newEmailVerification: 'Vérification du nouvel e-mail',
    newEmailPlaceholder: 'Entrez votre nouvel e-mail',
    change: 'Modifier',
    emailLowercaseToast: "L'e-mail doit être en minuscules.",
    newEmailEmptyToast: 'Veuillez saisir une nouvelle adresse e-mail',
    changeSuccessToast: 'Modifier avec succès',
    phonePlaceholder: 'Entrer le téléphone',
    currentEmail: 'E-mail actuel',
    passCurrentEmailVerificationFirst: "Réussir d'abord la vérification de l'e-mail actuel",
    currentEmailVerification: "Vérification de l'e-mail actuel",
    smsVerification: 'Vérification SMS',
    currentPhoneNumber: 'Numéro de téléphone actuel',
    currentPhoneVerification: 'Vérification du téléphone actuel',
    currentEmailAddress: 'Adresse e-mail actuelle',
    phoneVerification: 'Vérification par téléphone',
    enterVerificationCode: 'Entrez le code de vérification',
    newPhoneNumber: 'Nouveau numéro de téléphone',
    newEmail: 'Nouveau courriel'
  },
  withdrawAccount: {
    selectAccountType: 'Sélectionner le type de compte',
    noBasicLevelVerificationDialog:
      'Veuillez effectuer la vérification de niveau de base avant de lier la méthode de retrait.',
    bindNote: 'Veuillez saisir les informations de compte correctes, sinon votre retrait sera affecté.',
    bindBankAccount: 'Lier un compte bancaire',
    bindMobileMoneyAccount: 'Lier un compte Mobile Money',
    fieldEmptyToast: '{0} est requis',
    fieldLengthToast: 'Le {0} doit contenir au moins {1} caractères',
    bindBankRepeatToast: 'Ne liez pas le même compte bancaire à plusieurs reprises !',
    accountName: 'Nom du compte',
    ifscCode: 'Code IFSC',
    accountEmptyToast: 'Le compte est requis',
    accountNameEmptyToast: 'Le nom du compte est requis',
    phoneEmptyToast: 'Le téléphone est requis',
    emailEmptyToast: "L'e-mail est requis",
    ifscCodeEmptyToast: 'Le code IFSC est requis',
    ifscCodeLengthToast: 'Le code IFSC doit comporter 11 chiffres',
    bindIMPSRepeatToast: 'Ne liez pas le même compte IMPS à plusieurs reprises !',
    bindNote2:
      'Veuillez saisir votre adresse TRC-20 correcte. Une adresse erronée entraînera la perte du paiement, dont nous ne prenons aucune responsabilité.',
    usdtAddress: 'Adresse USDT (TRC-20) :',
    minimumLimit: 'Minimum de retrait par transaction : 10 $',
    usdtFee: 'Frais : Sous réserve des frais réels',
    registerGcash: "Si vous n'avez pas de compte Gcash, veuillez cliquer ici pour vous inscrire.",
    registerEpay: "Si vous n'avez pas de compte Epay, veuillez cliquer ici pour vous inscrire.",
    bindThirdPartyTitle: 'Lier le compte {0}',
    wrongAccountToast: 'Mauvais compte',
    accountFormatToast: 'Le format du compte est incorrect',
    bindThirdPartyFailedToast: 'La liaison {0} a échoué',
    queryFailedToast: 'Échec de la requête.',
    editFailedToast: 'Échec de la modification.',
    add: 'Ajouter',
    confirmEditDialog: 'Êtes-vous sûr de vouloir modifier le compte {0} ?',
    payPwdRequireDialog: "Veuillez définir un mot de passe de paiement à 6 chiffres avant d'ajouter un compte.",
    unbindFailedToast: 'Échec de la suppression',
    cashOutSuccessNote: "Heure d'arrivée estimée : dans les 7 jours ouvrables",
    requestSubmitted: 'Demande de retrait soumise',
    amountLimitToast1: 'Le montant du retrait doit être ≥ 40,00 $',
    amountLimitToast2: 'Le montant du retrait doit être ≥ {0},00 $',
    recommendAmountNote:
      "Conseils : Accumuler le montant à {0} $ avant le retrait permettra d'économiser efficacement vos frais de traitement.",
    amountNotEnoughToast: "Le montant du retrait n'est pas suffisant",
    exceedingLimitToast1: "Le montant du retrait d'aujourd'hui a atteint la limite supérieure",
    exceedingLimitToast2:
      "Le montant du retrait d'aujourd'hui a atteint la limite supérieure. Devez-vous terminer la certification avancée pour augmenter la limite ?",
    restrictedCountriesPayPalAccountToast:
      "N'utilisez pas de compte PayPal dans un pays restreint, ce qui entraînerait le blocage de votre Arripay",
    withdrawMinimumToast: 'Minimum de retrait par transaction : 40 $',
    bankNotAvailableToast: "Cette banque n'est plus disponible, veuillez lier d'autres banques.",
    usdtAccountInvalidToast:
      'Ce compte USDT ne peut pas effectuer de retrait, veuillez utiliser un nouveau compte pour le retrait.',
    noPayPwdToast: 'Veuillez définir un mot de passe de paiement à 6 chiffres avant le retrait.',
    editBankAccount: 'Modifier le compte bancaire',
    accountPlaceholder: 'Entrez votre compte',
    trc20Placeholder: "saisissez l'adresse TRC-20",
    accountRepeatToast: 'Le même que le mot de passe actuel.',
    unbindBankCardConfirmDialog: 'Êtes-vous sûr de vouloir dissocier la carte bancaire {0} ?',
    unbindMobileMoneyAccountConfirmDialog: "Êtes-vous sûr de vouloir dissocier le compte d'argent mobile {0} ?",
    unbindAccountConfirmDialog: 'Êtes-vous sûr de vouloir dissocier le compte {0} ?',
    availableBalance: 'Solde disponible {0}',
    estimatedFee: 'Frais estimés',
    submitFailToast: "Échec de l'envoi",
    disabledMethodToast: 'Ce canal est temporairement indisponible',
    channelUnavailableTitle: 'Canal indisponible',
    channelUnavailableNote: 'Ce canal de retrait est temporairement indisponible. Veuillez essayer une autre méthode.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Virement bancaire indisponible',
    bankTransferUnavailableNote:
      "Le virement bancaire n'est pas disponible pour votre compte pour le moment. Veuillez utiliser Epay pour retirer.",
    channelMaintenanceTitle: 'Canal en maintenance',
    channelMaintenanceNote: 'Ce canal de retrait est en maintenance. Veuillez essayer une autre méthode.',
    bankInfoUpdateTitle: 'Mettez à jour vos informations bancaires',
    bankInfoUpdateNote:
      "En raison d'un ajustement de la politique de la banque, veuillez mettre à jour vos coordonnées bancaires pour continuer.",
    bindEpay: 'Lier Epay',
    useEpay: 'Utiliser Epay',
    iMPSMaxLimitToast: 'Le montant maximum de retrait pour une seule transaction via ce canal est de 260 $',
    linkedAccount: 'Compte ajouté',
    otherAccounts: `D'autres comptes peuvent être ajoutés`,
    withdrawTo: 'Transférer vers',
    withdrawAmount: 'Montant du transfert',
    withdrawable: 'Retirable',
    documentIdToast: "Le numéro d'identification ne peut contenir que des chiffres",
    noAvailableMethodNote: 'Aucune méthode de retrait disponible',
    recommended: 'Recommandé'
  },
  paymentCode: {
    changePayPwd: 'Modifier le mot de passe de paiement',
    setPayPwd: 'Définir le mot de passe de paiement',
    setPayPwdNote: 'Veuillez définir un mot de passe de paiement à 6 chiffres',
    reenterPayPwdNote: 'Saisissez à nouveau',
    verificationNote: 'Veuillez passer la vérification pour le définir.',
    emailVerification: "Vérification de l'e-mail",
    inconsistentPasswordToast: 'Mot de passe incohérent',
    payPwdNote: 'Veuillez saisir le mot de passe de paiement',
    payPwdFormatToast: 'Le mot de passe de paiement est un nombre à 6 chiffres',
    payPwdWrongToast: 'Mot de passe de paiement incorrect',
    payPwdVerificationFailToast: 'La vérification du mot de passe de paiement a échoué !',
    successToast: 'Définition \n réussie'
  },
  authorize: {
    requirement:
      '{0} doit acquérir les informations suivantes de votre MetWallet{1} pour vous fournir le service associé. Pseudonyme, avatar, sexe, etc.',
    authorize: 'Autoriser',
    switchAccount: 'Changer de compte',
    goToMetWallet: 'Accéder à MetWallet',
    notMatchTips: "L'opération a échoué. Vous ne pouvez activer la connexion rapide qu'avec votre compte MetWallet lié"
  },
  basicLevel: {
    namePlaceholder: 'Pas de symboles, de chiffres',
    verification: 'Vérification',
    whatsAvailable: 'Ce qui est disponible',
    cashOut: 'Retrait',
    withdrawLimit: '50 $ par jour',
    basicLevelNote:
      'Veuillez saisir vos vraies informations personnelles. De fausses informations peuvent entraîner un échec de retrait.',
    fieldEmptyToast: 'Veuillez remplir tous les champs obligatoires.',
    successToast: 'Enregistré \n avec succès',
    failToast: "Échec de l'enregistrement",
    confirmDialog:
      'Assurez-vous de saisir vos vraies informations personnelles. De fausses informations peuvent entraîner un échec de retrait.',
    birthdayFormatToast: "Format de champ d'anniversaire incorrect",
    verificationCodeError: 'Erreur de code de vérification',
    verificationCodeEmpty: 'Code de vérification vide',
    noEmailCodeToast: 'Veuillez obtenir le code de vérification par e-mail',
    checkDialogTitle: 'Vérifiez vos informations',
    checkDialogContent:
      'Pour retirer avec succès, veuillez vérifier vos informations. De fausses informations peuvent entraîner un échec de retrait.',
    check: 'Vérifier'
  },
  semiVerified: {
    uploadPhotoId: "Télécharger une pièce d'identité avec photo",
    photoId: "Pièce d'identité avec photo",
    resubmit: 'Soumettre à nouveau',
    limit: '5000$ par jour',
    uploading: 'Téléchargement...',
    notUploadProofToast: "Veuillez télécharger une preuve de carte d'identité"
  },
  fullyVerified: {
    frontOfId: 'Recto de la pièce',
    backOfId: 'Verso de la pièce',
    uploadIdFront: 'Télécharger le recto',
    uploadIdBack: 'Télécharger le verso',
    withdrawDailyHint: 'Renseignez les infos pour retirer > {0} par jour.',
    notUploadIdToast: 'Veuillez télécharger le recto et le verso de votre pièce',
    proofTitle: 'JUSTIFICATIF DE RÉSIDENCE',
    acceptableProof: 'UN JUSTIFICATIF DE RÉSIDENCE ACCEPTABLE EST :',
    acceptableProof1: 'Un relevé de compte bancaire.',
    acceptableProof2: 'Une facture de services publics (électricité, eau, Internet, etc.).',
    acceptableProof3: "Un document émis par le gouvernement (relevé d'impôt, certificat de résidence, etc.).",
    unacceptableProof:
      "Nous ne pouvons pas accepter l'adresse figurant sur votre pièce d'identité soumise comme preuve de résidence valide.",
    limit: '10 000 $ par jour',
    notUploadToast: 'Veuillez télécharger un justificatif de domicile',
    incorrectFormatToast: 'Veuillez télécharger une image au format jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'Mot de passe',
    lastLogin: 'Dernière connexion',
    moreOptions: "Plus d'options",
    agreeCheckboxContent: 'Acceptez les {0} et {1}',
    userAgreement: "Contrat d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
    notAgreeToast: "Acceptez le contrat d'utilisation et la politique de confidentialité",
    forgotPassword: 'Mot de passe oublié',
    linkedMail: 'E-mail associé',
    verificationCode: 'Code de vérification',
    newPwd: 'Nouveau mot de passe',
    repeatPwd: 'Répéter le mot de passe',
    confirmPwd: 'Confirmer le mot de passe',
    noLinkedEmailToast: 'Aucun e-mail associé à votre compte',
    unregisteredToast: "Ce numéro n'a pas été enregistré",
    pwdFormatToast: 'Le format du mot de passe est incorrect',
    resetSuccessToast: 'Réinitialiser \n avec succès',
    pwdNotMatchToast: 'Les mots de passe ne correspondent pas deux fois',
    emailFormatToast: "Format d'e-mail incorrect",
    phoneNumberFormatToast: 'Format de numéro de téléphone incorrect',
    invalidAreaCodeToast: 'Indicatif régional invalide',
    login: 'Connexion',
    pwdLogin: 'Connexion via mot de passe',
    emailCodeLogin: "Connexion via code de vérification d'e-mail",
    smsLogin: 'Connexion via SMS',
    verifyEmail: "Vérifier l'e-mail",
    verifyPhone: 'Vérifier le téléphone',
    accountDangerDialog:
      'Votre compte a été détecté comme étant dangereux. Veuillez revérifier votre compte, sinon votre compte ne pourra plus être utilisé.',
    sendEmailCodeDialog:
      'Nous avons envoyé un code de vérification à votre adresse e-mail {0}. Veuillez saisir le code de vérification.',
    sendSmsCodeDialog:
      'Nous avons envoyé un code de vérification à votre téléphone {0}. Veuillez saisir le code de vérification.',
    graphicCodeEmptyToast: 'Veuillez saisir le code graphique.',
    countryUnselectToast: "Veuillez d'abord choisir votre pays",
    unsupportedLoginTypeToast: 'Type de connexion non pris en charge',
    pwdWrongLimitOverDialog:
      'Le mauvais mot de passe a été saisi 3 fois. Veuillez utiliser le code de vérification SMS pour vous connecter.',
    loginFailedToast: 'Connexion échouée',
    signIn: 'Se connecter',
    pwdPlaceholder: 'Saisissez le mot de passe',
    pwdNote: '8-16 caractères incluant lettres et chiffres',
    reenterPwdPlaceholder: 'Saisissez à nouveau le mot de passe',
    reenterPwdNote: 'Veuillez saisir à nouveau le mot de passe',
    createAccount: 'Créer un compte',
    chooseCountryNote: 'Veuillez choisir le pays',
    pwdInconsistentToast: 'Pas le même que le mot de passe précédent que vous avez saisi',
    createSuccessToast: 'Créer \n avec succès',
    registerFailToast: "Échec de l'inscription",
    userNotExistToast: "L'utilisateur n'existe pas",
    phoneIncorrectToast: 'Veuillez vérifier votre téléphone',
    userExistToast: "L'utilisateur existe déjà",
    countryCodeRepeatToast: 'Veuillez ne pas saisir le code du pays à plusieurs reprises !',
    logoutDialog: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    pwdRequirement: 'Le mot de passe doit comporter au moins 8 à 16 caractères avec des lettres et des chiffres',
    signup: 'Inscription',
    registerSuccessToast: 'Inscription \n réussie',
    oldPwdErrorToast: 'Veuillez vérifier votre ancien mot de passe'
  },
  checkUserInfo: {
    title: 'Centre de gestion',
    emptyInfoNote:
      'Voici aucune information pour le compte actuel, veuillez vérifier le compte MetWallet que vous devez vérifier.',
    infoNote: 'Voici vos informations de vérification.',
    lastSuccessWithdrawal: 'Dernier retrait réussi ',
    copyBtn: 'Copie',
    successToast: 'Copié avec succès !',
    failToast: 'Échec de la copie !'
  },
  country: {
    title: 'Sélectionnez la région',
    popular: 'Populaire'
  },
  documentDetails: {
    title: 'Détails du document',
    contract: 'Contrat',
    goToSign: 'Allez le signer',
    download: 'Télécharger',
    upload: 'Télécharger',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., documents uniquement.',
    contentEmptyToast: 'Veuillez saisir le contenu',
    placeOfBirth: 'Lieu de naissance',
    occupation: 'Occupation',
    fileForm: '(Formulaire de fichier)',
    proofOfAddress: "Preuve d'adresse en anglais",
    residenceDoc: 'Document de résidence',
    textForm: '(Formulaire texte)',
    contractAgent: 'Agent contractuel',
    contractPayslip: 'Bulletin de paie contractuel',
    uncompletedToast: 'Veuillez le remplir pour soumettre',
    successToast: 'Soumettre avec succès',
    undefinedFileTypeToast: 'Type de téléchargement de fichier non défini',
    uploadFailToast: 'Téléchargement échoué'
  },
  filters: {
    amount: 'Montant',
    filter: 'Filtres',
    time: 'Heure',
    reset: 'Réinitialiser',
    timePickerTitle: 'Sélectionner {0} Heure',
    start: 'Début',
    end: 'Fin',
    maximum: 'Maximum',
    minimum: 'Minimum'
  },
  home: {
    balance: 'Solde',
    transactions: 'Transactions',
    availableBalance: 'Solde disponible',
    noWithdrawalMethodToast: 'Au moins une méthode de retrait est nécessaire.',
    linkAccount: 'Lier le compte',
    all: 'Tous',
    cashIn: 'Retrait',
    loading: 'chargement...',
    noMore: 'Plus aucune transaction',
    reload: 'Échec du chargement, cliquez pour recharger',
    receivedFrom: 'Reçu de',
    transferredTo: 'Transféré à',
    fee: 'Frais de transfert vers',
    myEmail: 'Mon e-mail',
    myPhone: 'Mon téléphone',
    invalidBasicLevelDialog:
      "En raison de l'inclusion de symboles, d'espaces ou de chiffres dans le champ de votre nom, le retrait du compte n'est pas possible. Veuillez remplir à nouveau les informations de base (assurez-vous que le nom n'inclut pas de symboles, d'espaces ou de chiffres et si vous n'avez pas de nom de famille ou de deuxième prénom, laissez-le simplement vide.)",
    lackLastNameDialog: "Votre nom de famille n'est pas renseigné, ce qui entravera votre retrait.",
    fillIn: 'Remplir',
    viewDetails: 'Afficher les détails',
    docReviewingDialogTitle: 'Veuillez attendre que le document soit transmis.',
    docReviewingDialogContent:
      'Vous avez soumis le document, mais vous ne pouvez pas utiliser MetWallet avant que votre document ne soit transmis.<br>Le personnel officiel le traitera bientôt, veuillez patienter un peu.',
    docPassedDialog:
      'Le document que vous avez soumis est transmis. <br>Vous pouvez utiliser MetWallet normalement maintenant.',
    docUnqualifiedDialog: "Le document que vous avez soumis n'est pas qualifié. <br>Veuillez en soumettre un qualifié.",
    goToSubmit: 'Allez le soumettre',
    uncompletedDialog: 'Vous devez le compléter pour utiliser MetWallet normalement',
    useMetWalletNormallyAfterPassed: 'Vous pouvez utiliser MetWallet normalement une fois le document transmis.',
    requireSemiVerifiedDialog:
      "{0}, pour l'exigence de la banque, vous devez terminer la partie semi-vérifiée dans les 48 heures pour un retrait réussi.",
    goToVerify: 'Allez vérifier',
    emailInvalidDialog:
      "{0}, votre adresse e-mail est la même que celle d'une autre personne. Pour une assurance de confidentialité, veuillez saisir votre propre adresse e-mail dès que possible.",
    later: 'Plus tard',
    transferRequireSemiVerifiedDialog: 'Veuillez effectuer la vérification semi-vérifiée avant le transfert.',
    modifyBtnText: 'Modifier mes informations',
    unmodifiedTitle: 'Impossible de modifier',
    unmodifiedContent:
      'Vous avez un ordre de retrait en cours. Les informations ne peuvent pas être modifiées pour le moment.'
  },
  signing: {
    signature: 'Signature',
    date: 'Date',
    employeeName: "Nom de l'employé",
    designation: 'Fonction',
    month: 'Mois',
    year: 'Année',
    earnings: 'Revenus',
    deductions: 'Déductions',
    basic: 'Base et DA (USD)',
    totalAddition: 'Ajout total',
    totalDeduction: 'Déduction totale',
    salary: 'Salaire NET',
    refNo: 'N° de référence',
    paymentTransferDate: 'Date de transfert du paiement',
    nameOfBank: 'Nom de la banque',
    signatureOfEmployee: "Signature de l'employé",
    director: 'Directeur',
    signNote: 'Veuillez signer votre nom',
    preview: 'Aperçu',
    clear: 'Effacer',
    save: 'Enregistrer',
    noSignatureToast: 'Vous ne pouvez pas enregistrer sans signature.',
    fieldEmptyToast: 'Veuillez remplir toutes les informations.'
  },
  transactionDetail: {
    title: 'Détails de la transaction',
    status: 'Statut',
    pending: 'En attente',
    completed: 'Terminé',
    success: 'SUCCÈS',
    failed: 'Échec',
    cancelled: 'Annulé',
    onHold: 'En attente',
    reason: 'Raison du statut',
    description: 'Description',
    creationDate: 'Date de création',
    lastStatusDate: 'Dernier statut',
    requestedAmount: 'Montant demandé',
    receiveAmount: 'Montant reçu',
    transferAmount: 'Montant du transfert',
    amountToPay: 'Montant à payer',
    transferFee: 'Frais de transfert',
    processingFee: 'Frais de traitement',
    method: 'Méthode',
    country: 'Pays',
    name: 'Nom',
    bankPendingText: 'En révision bancaire finale',
    pendingText: 'En cours de révision {0}',
    chametSalary: 'Salaire Chamet',
    userSalary: 'Salaire de l\'utilisateur',
    comm: 'Comm.',
    gemgalaSalary: 'Salaire Gemgala'
  },
  transfer: {
    title: 'Vers le compte MetWallet',
    noPayPwdDialog: 'Veuillez définir un mot de passe de paiement à 6 chiffres avant le transfert.',
    records: 'Enregistrements',
    cashInOut: 'Encaissement {0}, retrait {1}',
    transfer: 'Transfert',
    fee: 'Frais',
    remark: 'Remarque',
    transferTo: 'Transfert vers {0}',
    remarkPlaceholder: 'Ajouter une remarque sur le transfert (moins de 100 caractères)',
    firstNameNote: 'Veuillez saisir son prénom',
    sendingAmount: 'Montant envoyé',
    receivingAmount: 'Montant reçu',
    transferNow: 'Transférer maintenant',
    noBalanceToast: 'Le montant du transfert est supérieur au montant du solde.',
    amountTooLittleToast: 'Le montant du transfert ne peut pas être inférieur à 10 $.'
  },
  bankData: {
    beneficiaryName: 'Nom du bénéficiaire',
    beneficiaryNamePlaceholder: 'Entrez le nom',
    beneficiaryLastname: 'Nom de famille du bénéficiaire',
    beneficiaryLastnamePlaceholder: 'Entrez le nom de famille',
    bankCode: 'Code bancaire',
    bankCodePlaceholder: 'Sélectionnez le code bancaire',
    bankIFSCCode: 'Code IFSC de la banque',
    bankIFSCCodePlaceholder: 'Entrez le IFSC de la banque',
    bankAccount: 'Compte bancaire',
    bankAccountPlaceholder: 'Entrez le compte bancaire',
    email: 'E-mail',
    emailPlaceholder: "Entrez l'e-mail",
    phoneNumber: 'Numéro de téléphone',
    phoneNumberPlaceholder: 'Entrez le numéro de téléphone',
    address: 'Adresse',
    addressPlaceholder: "Entrez l'adresse",
    city: 'Ville',
    cityPlaceholder: 'Entrez la ville',
    state: 'État',
    statePlaceholder: "Entrez l'État",
    postCode: 'Code postal',
    postCodePlaceholder: 'Entrez le code postal',
    documentId: 'ID du document',
    documentIdPlaceholder: "Entrez l'ID du document",
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Type de document',
    documentTypePlaceholder: 'Sélectionnez le type de document',
    accountType: 'Type de compte',
    accountTypePlaceholder: 'Sélectionnez le type de compte',
    cpfcnpjPlaceholder: 'Entrez CPFCNPJ',
    bankBranch: 'Agence bancaire',
    bankBranchPlaceholder: "Entrez l'agence bancaire",
    ribOfBankAccount: 'RIB du compte bancaire',
    bankName: 'Nom de la banque',
    bankNamePlaceholder: 'Entrez le nom de la banque',
    bicCode: 'Code BIC',
    bicCodePlaceholder: 'Entrez le code BIC',
    ibanPlaceholder: "Entrez l'IBAN",
    bankSwift: 'Swift bancaire',
    bankSwiftPlaceholder: 'Entrez le Swift bancaire',
    name: 'Nom',
    documentCountry: 'Pays du document',
    documentCountryPlaceholder: 'Sélectionnez le pays du document',
    issueDate: "Date d'émission du document",
    issueDatePlaceholder: "Sélectionnez la date d'émission",
    expireDate: "Date d'expiration du document",
    expireDatePlaceholder: "Sélectionnez la date d'expiration",
    bankBranchName: "Nom de l'agence bancaire",
    bankBranchNamePlaceholder: "Entrez le nom de l'agence",
    branchPlaceholder: "Entrez l'agence",
    gender: 'Sexe',
    genderPlaceholder: 'Sélectionnez Sexe',
    birthday: 'Anniversaire',
    birthdayPlaceholder: "Sélectionnez l'anniversaire",
    phone: 'Téléphone',
    bankAddress: 'Adresse de la banque',
    bankAddressPlaceholder: "Entrez l'adresse de la banque",
    bankAccountName: 'Nom du compte bancaire',
    bankAccountNamePlaceholder: 'Entrez le nom du compte bancaire',
    province: 'Province',
    provincePlaceholder: 'Entrez la province',
    postalCode: 'Code postal',
    postalCodePlaceholder: 'Entrez le code postal',
    savingsAccount: "Compte d'épargne",
    abaRoutingNumber: "Numéro d'acheminement ABA",
    englandBankAccount: 'Compte bancaire en Angleterre',
    bankBranch2: 'bankBranch',
    bankBranch2Placeholder: 'Uniquement si la banque est Santander',
    paternalName: 'Nom paternel',
    paternalNamePlaceholder: 'Entrez le nom paternel',
    passportIdNumber: "Numéro d'identification du passeport",
    bankNamePlaceholder2: 'Sélectionnez le nom de la banque',
    areaCode: 'Indicatif régional',
    phoneNumberNoAreaCode: 'Numéro de téléphone (sans indicatif régional)',
    idType: "Type d'identifiant",
    idNo: "Numéro d'identifiant",
    idIssueDate: "Date d'émission de l'identifiant",
    idExpireDate: "Date d'expiration de l'identifiant",
    ibanStyleToast: "Veuillez saisir un contenu commençant par 'SA' et d'une longueur de 24 caractères."
  },
  rechargeAndTransfer: {
    transfer_limit_1: "Vous ne pouvez transférer qu'à des vendeurs de diamants",
    search: 'Rechercher',
    history: 'Utilisateurs transférés',
    confirm_content: 'Êtes-vous sûr de transférer {0} à {1}',
    success_content: '{0} a été transféré à {1}',
    purchase: 'Achat',
    purchase_success: 'Vous avez acheté avec succès {0}',
    insufficient_balance: 'Solde insuffisant',
    purchase_diamond: 'Acheter des diamants',
    transfer_limit_2: 'Le montant du transfert doit être compris entre 10 $ et 30 000 $',
    no_data: 'Aucune donnée',
    invalid_number: 'Veuillez saisir un numéro valide',
    under_limit: 'Le montant du transfert ne doit pas être inférieur à 10 $',
    over_limit: 'Le montant du transfert doit être inférieur à 30 000 $'
  },
  redesign: {
    emailPlaceholder: "Entrez l'adresse e-mail",
    retrievePwd: 'Récupérer le mot de passe',
    resetPwd: 'Réinitialiser le mot de passe',
    newPwdPlaceholder: 'Entrez un nouveau mot de passe',
    reenterNewPwdPlaceholder: 'Saisissez à nouveau le nouveau mot de passe',
    reenterPayPwdPlaceholder: 'Veuillez saisir à nouveau le mot de passe de paiement',
    sendToPhone: 'Le code de vérification a été envoyé sur votre téléphone',
    sendToWhatsapp: 'Le code de vérification a été envoyé sur votre WhatsApp',
    sendToEmail: 'Le code de vérification a été envoyé à votre e-mail',
    invalidCode: 'Code invalide',
    userId: 'Identifiant utilisateur',
    other: 'Autre',
    transactionRecord: 'Enregistrement de transaction',
    bankCardInfo: 'Compte de carte bancaire',
    withdrawInfo: 'Compte de retrait',
    toFillIn: 'À remplir',
    walletInfo: 'Informations sur le compte de portefeuille',
    toComplete: 'À compléter',
    verifyGuide:
      'Complétez les informations sur le compte de portefeuille pour obtenir plus de qualifications de retrait',
    verifyNote: 'Complétez les informations suivantes pour obtenir des qualifications de retrait quotidien de {0}',
    verifyCompletedNote: 'Les informations sont complétées pour obtenir des qualifications de retrait quotidien de {0}',
    continueBtnText: 'Continuer à remplir',
    submitInfo: 'Soumettre les informations',
    transferAmount: 'Montant du transfert',
    newEmailVerify: "Nouvelle vérification de l'e-mail",
    verifyCodePlaceholder: 'Entrez le code de vérification',
    emailIncorrectToast: 'Veuillez saisir une adresse e-mail correcte',
    newPhone: 'Nouveau numéro de téléphone',
    accountAdded: 'Informations sur le compte ajoutées',
    accountToAdd: "D'autres comptes peuvent être ajoutés",
    edit: 'Modifier',
    enterPayPwd: 'Entrez le mot de passe de paiement',
    deleteBtnText: 'Supprimer',
    transferTo: 'Transférer vers',
    withdrawable: 'Retirable',
    goSet: 'Aller régler',
    goModify: 'Aller modifier'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/fr.js